import './styles.less';

import {Spin} from 'antd';
import React from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';

import {useAuth} from './AuthContext';
import {AppLayout} from './main/app-layout/Layout';
import {PageNotFound} from './main/pages/404';
import {DashboardPage} from './main/pages/dashboard/DashboardPage';
import {EbayPage} from './main/pages/ebay/EbayPage';
import {GroupSaleDetail} from './main/pages/group_sale/GroupSaleDetailPage';
import {GroupSaleList} from './main/pages/group_sale/GroupSaleList';
import {LoginPage} from './main/pages/login/LoginPage';
import {PalletOrderCreatePage} from './main/pages/pallet_orders/PalletOrderCreatePage';
import {PalletOrderDetailPage} from './main/pages/pallet_orders/PalletOrderDetailPage';
import {PalletOrderListPage} from './main/pages/pallet_orders/PalletOrderListPage';
import {ProductCreatePage} from './main/pages/products/ProductCreatePage';
import {ProductDetailPage} from './main/pages/products/ProductDetailPage';
import {ProductListPage} from './main/pages/products/ProductListPage';
import {UserPage} from './main/pages/users/UserPage';
import {WorkerPage} from './main/pages/worker/WorkerPage';
import styles from './styles.module.less';

function MainApp() {
    const auth = useAuth();
    const navigate = useNavigate();

    if (auth?.loaded) {
        return (
            <Routes>
                <Route
                    path="/login"
                    element={<LoginPage />}
                />

                <Route
                    path={'/'}
                    element={<AppLayout />}
                >
                    <Route
                        index
                        element={<DashboardPage />}
                    />
                    <Route
                        path="/dashboard"
                        element={<DashboardPage />}
                    />

                    <Route path={'/products'}>
                        <Route
                            index
                            element={<ProductListPage />}
                        />

                        <Route
                            path={':id'}
                            element={<ProductDetailPage />}
                        />

                        <Route
                            path={'new'}
                            element={<ProductCreatePage />}
                        />
                    </Route>
                    <Route path={'/pallet-orders'}>
                        <Route
                            index
                            element={<PalletOrderListPage />}
                        />

                        <Route
                            path={'new'}
                            element={<PalletOrderCreatePage />}
                        />

                        <Route
                            path={':id'}
                            element={<PalletOrderDetailPage />}
                        />
                    </Route>
                    <Route path={'/group-sales'}>
                        <Route
                            index
                            element={<GroupSaleList />}
                        />
                        <Route
                            path={':id'}
                            element={<GroupSaleDetail />}
                        />
                    </Route>

                    <Route
                        path="/users"
                        element={<UserPage />}
                    />
                    <Route
                        path="/worker"
                        element={<WorkerPage />}
                    />
                    <Route
                        path="/ebay"
                        element={<EbayPage />}
                    />
                </Route>
                <Route
                    path="*"
                    element={<PageNotFound />}
                />
            </Routes>
        );
    } else {
        return (
            <Spin
                spinning
                rootClassName={styles.loaderWrapper}
            />
        );
    }
}

function ProtectedRoute({children}: {children: JSX.Element}) {
    const auth = useAuth();
    if (auth?.user === null) {
        return <LoginPage />;
    }
    // let location = useLocation();

    // if (!auth.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    // return <Navigate to="/login" state={{from: location}} replace/>;
    // }

    return children;
}

export default MainApp;
